<div class="modal-header">
  <span class="popup-title header-num">{{ editMode ? 'Edit CI/CD Execution (2/2)' : 'Add New CI/CD Execution (2/2)' }}</span>
  <button type="button" class="cicd-close-btn" (click)="onCancel()" aria-label="Close">
    <i class="bi bi-x-circle"></i>
  </button>
</div>

<div class="step2-body">

  <!-- ── 0. Execution name ──────────────────────────────────────────────── -->
  <div class="execution-name-field">
    <label class="execution-name-label" for="executionName">Execution name</label>
    <input
      id="executionName"
      type="text"
      class="form-control execution-name-input"
      placeholder="Add Execution name"
      [(ngModel)]="executionName"
      maxlength="200" />
  </div>

  <!-- ── 1. Link to release ──────────────────────────────────────────────── -->
  <app-feature-toggle-card
    title="Link to release"
    description="Link this execution to a release to enable end-to-end version tracking and actionable analytics"
    [(enabled)]="linkToRelease"
    (enabledChange)="$event ? onLinkToReleaseEnabled() : onLinkToReleaseDisabled()">

    <!-- ── State A: existing release dropdown ──────────────────────────── -->
    <ng-container *ngIf="!showReleaseForm">
      <div class="release-field">
        <label class="release-label" for="releaseSelect">
          Release <span class="required-star">*</span>
        </label>
        <div class="release-select-wrap">
          <select
            id="releaseSelect"
            class="form-select release-select"
            [(ngModel)]="selectedReleaseId"
            [disabled]="isLoadingReleases">
            <option value="" disabled>Select release</option>
            <option *ngFor="let r of releases" [value]="r.id">{{ r.name }}</option>
          </select>
          <mat-progress-spinner
            *ngIf="isLoadingReleases"
            mode="indeterminate"
            [diameter]="18"
            class="release-spinner">
          </mat-progress-spinner>
        </div>
        <button type="button" class="add-release-link" (click)="addNewRelease()">
          + Add a new release
        </button>
      </div>
    </ng-container>

    <!-- ── State B: inline create form ────────────────────────────────── -->
    <ng-container *ngIf="showReleaseForm">
      <div class="release-form-card">
        <div class="rfc-header-row">
          <span class="release-label">New Release</span>
          <div class="rfc-actions">
            <button
              type="button"
              class="rfc-btn rfc-btn--confirm"
              (click)="confirmRelease()"
              [disabled]="releaseForm.invalid || isCreatingRelease"
              title="Confirm">
              <mat-progress-spinner
                *ngIf="isCreatingRelease"
                mode="indeterminate"
                [diameter]="14">
              </mat-progress-spinner>
              <img
                *ngIf="!isCreatingRelease"
                src="assets/images/virtusa-icons/correct.svg"
                alt="Confirm" />
            </button>
            <button
              type="button"
              class="rfc-btn rfc-btn--discard"
              (click)="cancelRelease()"
              [disabled]="isCreatingRelease"
              title="Go back">
              <img src="assets/images/virtusa-icons/close-red.svg" alt="Go back" />
            </button>
          </div>
        </div>
        <app-dynamic-form
          [form]="releaseForm"
          [formFields]="releaseFields">
        </app-dynamic-form>
      </div>
    </ng-container>

  </app-feature-toggle-card>

  <!-- ── 2. Test failure analysis ───────────────────────────────────────── -->
  <app-feature-toggle-card
    title="Test failure analysis"
    description="Enable automated root cause analysis for test execution failures and automatically suggest possible resolutions"
    [(enabled)]="testFailureAnalysis">
  </app-feature-toggle-card>

  <!-- ── 3. UI Self-healing ─────────────────────────────────────────────── -->
  <app-feature-toggle-card
    title="UI Self-healing"
    description="Automatically resolve UI locator mismatches during test execution to prevent script failures"
    [(enabled)]="uiSelfHealing">
  </app-feature-toggle-card>

</div>

<div class="modal-footer d-flex justify-content-between align-items-center">
  <button type="button" class="btn-back" (click)="onBack()">
    <i class="bi bi-arrow-left"></i>
    Back
  </button>
  <div class="d-flex gap-2">
    <button type="button" class="btn btn-accello-secondary" (click)="onCancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-accello-primary-light d-flex align-items-center gap-2"
      (click)="onSave()"
      [disabled]="isSaveDisabled || isSaving">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      {{ editMode ? 'Update' : 'Save' }}
    </button>
  </div>
</div>
